/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Applications_Tracked_CountInputs */

const en_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} application${i?.plural} tracked`)
};

const de_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Bewerbung${i?.plural} verfolgt`)
};

const fr_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} candidature${i?.plural} suivie${i?.plural}`)
};

const es_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} solicitud${i?.plural} en seguimiento`)
};

const it_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} candidatura${i?.plural} monitorata`)
};

const nl_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sollicitatie${i?.plural} bijgehouden`)
};

const pl_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} aplikacja${i?.plural} śledzona`)
};

const fi_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} hakemus${i?.plural} seurannassa`)
};

const da_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ansøgning${i?.plural} sporet`)
};

const sv_applications_tracked_count = /** @type {(inputs: Applications_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ansökan${i?.plural} spårad`)
};

/**
* | output |
* | --- |
* | "{count} application{plural} tracked" |
*
* @param {Applications_Tracked_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_tracked_count = /** @type {((inputs: Applications_Tracked_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Tracked_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_tracked_count(inputs)
	if (locale === "fr") return fr_applications_tracked_count(inputs)
	if (locale === "es") return es_applications_tracked_count(inputs)
	if (locale === "it") return it_applications_tracked_count(inputs)
	if (locale === "nl") return nl_applications_tracked_count(inputs)
	if (locale === "pl") return pl_applications_tracked_count(inputs)
	if (locale === "fi") return fi_applications_tracked_count(inputs)
	if (locale === "da") return da_applications_tracked_count(inputs)
	if (locale === "sv") return sv_applications_tracked_count(inputs)
	return en_applications_tracked_count(inputs)
});